import { render, staticRenderFns } from "./Userorderdsm.vue?vue&type=template&id=d3824056&scoped=true&"
import script from "./Userorderdsm.vue?vue&type=script&lang=js&"
export * from "./Userorderdsm.vue?vue&type=script&lang=js&"
import style0 from "./Userorderdsm.vue?vue&type=style&index=0&id=d3824056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3824056",
  null
  
)

export default component.exports